import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const TrimsInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Trims"
    sectionDisplayName="Trims Section"
    backRoute="/sections/trims"
  />
);

export default TrimsInwardConsignment;
